import React, {useContext, useEffect} from 'react';
import {
    TrackingContext,
    TrackingContextValue,
} from '@homeaway/react-event-tracking';
import {Button} from '@homeaway/react-buttons';
import {SVGIcon} from '@homeaway/react-svg';
import classnames from 'classnames';
import './FilterPill.less';
import {GENERIC_EVENT} from '../../utils/edap';

interface FilterPillProps {
    label?: string;
    appliedCount?: number;
    leftAlign?: boolean;
    icon?: string;
    rotateIcon?: boolean;
    applied?: boolean;
    loading?: boolean;
    focused?: boolean;
    onClick?: Function;
    edapLabel?: string;
}

/* eslint-disable complexity */
const FilterPill = ({
    label = '',
    appliedCount,
    leftAlign = false,
    rotateIcon = false,
    icon,
    applied = false,
    focused = false,
    loading = false,
    onClick,
    edapLabel,
}: FilterPillProps) => {
    const edapContext: TrackingContextValue = useContext(TrackingContext);

    useEffect(() => {
        if (edapLabel) {
            const eventFields = {
                eventaction: 'filter group presented',
                eventlabel: edapLabel,
            };
            edapContext.trigger(GENERIC_EVENT, eventFields);
        }
    }, [edapContext, edapLabel]);

    function handleClick(event: MouseEvent): void {
        if (onClick) {
            onClick(event);
        }

        if (edapLabel) {
            const eventFields = {
                eventaction: 'filter group clicked',
                eventlabel: edapLabel,
            };
            edapContext.trigger(GENERIC_EVENT, eventFields);
        }
    }

    if (loading) {
        return (
            <Button
                className="FilterPill"
                disabled
                label={<div className="bg--shimmer FilterPill--loading" />}
                size="xs"
            />
        );
    }

    const svgIcon = <SVGIcon inlineFlex markup={icon} aria-hidden />;

    const className = classnames('FilterPill', {
        'FilterPill--applied': applied,
        'FilterPill--focused': focused,
        'FilterPill--rotate-icon': rotateIcon,
    });

    return (
        <Button
            className={className}
            size="xs"
            onClick={handleClick}
            label={
                <>
                    {leftAlign && svgIcon}
                    <span>{label}</span>
                    {!!appliedCount && appliedCount > 0 && (
                        <span className="FilterPill__count">{`(${appliedCount})`}</span>
                    )}
                    {!leftAlign && svgIcon}
                </>
            }
        />
    );
};

export default FilterPill;
export {FilterPill};
